"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BriefBlock = _interopRequireDefault(require("../../../../BriefBlock"));

var _IconRadioButtons = _interopRequireDefault(require("./IconRadioButtons"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var CREATIVE_INPUT_INDEX_MAP = ['EXACT', 'BRIEF', 'FULL'];
var CREATIVE_RADIO_BUTTONS = [{
  icon: 'briefexact',
  label: 'FOLLOW EXACTLY'
}, {
  icon: 'briefbasic',
  label: 'FOLLOW BRIEFLY'
}, {
  icon: 'creative',
  label: 'FULL CREATIVE EDIT'
}];

function onSelectCreativeInput(onChangeField) {
  return function (index) {
    onChangeField(CREATIVE_INPUT_INDEX_MAP[index]);
  };
}

function CreativeInputSection(_ref) {
  var onChangeField = _ref.onChangeField,
      creativeInput = _ref.creativeInput,
      canUpdateVideo = _ref.canUpdateVideo;
  return (/*#__PURE__*/_react.default.createElement(_BriefBlock.default, {
      title: "CREATIVE INPUT"
    }, /*#__PURE__*/_react.default.createElement(_IconRadioButtons.default, {
      onChange: onSelectCreativeInput(onChangeField('creativeInput')),
      selectedIndex: CREATIVE_INPUT_INDEX_MAP.findIndex(function (value) {
        return creativeInput === value;
      }),
      options: CREATIVE_RADIO_BUTTONS,
      canUpdateVideo: canUpdateVideo
    }))
  );
}

var _default = (0, _react.memo)(CreativeInputSection);

exports.default = _default;